import { render, staticRenderFns } from "./approve-dialog.vue?vue&type=template&id=7969f5dd&"
import script from "./approve-dialog.vue?vue&type=script&lang=js&"
export * from "./approve-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports